export default () => ({
  open: '',
  init() {
    this.$watch('open', (v, vo) => {
      if (v) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });
  }
})
